import { EndemicImage } from "@/app/(components)/Basic/Image";
import CloseIcon from "@/assets/icons/close-thin.svg";
import { MEDIA_TYPE } from "@/shared/media";
import { UploadedImage } from "../types";

export interface Props {
  id: string;
  images?: UploadedImage[];
  onImageRemove: (id: string) => void;
  displayAddButton?: boolean;
  maxGallerySize?: number;
  isErrorVisible?: boolean;
}

export default function FeedUpsertImages({
  id,
  images,
  onImageRemove,
  displayAddButton,
  maxGallerySize,
  isErrorVisible,
}: Props) {
  return (
    <>
      {images && (
        <>
          <div className="flex flex-wrap mt-[6px]">
            {images.map((image, i) => {
              return (
                <div
                  key={i}
                  className="w-[100px] h-[100px] relative rounded-3xl overflow-hidden mr-2 mb-2"
                >
                  {image.mediaType === MEDIA_TYPE.VIDEO ? (
                    <video
                      src={image.imageUrl}
                      className="object-cover w-full h-full"
                      autoPlay
                      loop
                      muted
                      playsInline
                    />
                  ) : (
                    <EndemicImage
                      alt={"post image " + image.imageUrl}
                      src={image.imageUrl!}
                      placeholder={image.imagePlaceholder}
                      fill
                      className="object-cover"
                    />
                  )}
                  <span
                    className="absolute rounded-full cursor-pointer flex items-center justify-center w-7 h-7 text-white bg-overlay z-10 right-2 top-2 p-2"
                    onClick={() => onImageRemove(image.id)}
                  >
                    <CloseIcon className="fill-[#b5b5b5]" />
                  </span>
                </div>
              );
            })}
            {images.length > 0 && images.length < 10 && displayAddButton && (
              <label
                className="w-[100px] h-[100px] border rounded-3xl cursor-pointer flex items-center justify-center text-endemicGray-700 endemic:text-primary"
                htmlFor={`${id}-uploadGallery`}
              >
                +
              </label>
            )}
          </div>
          {isErrorVisible && (
            <div className="text-red">
              Maximum number of images is {maxGallerySize}
            </div>
          )}
        </>
      )}
    </>
  );
}
